import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Table from './components/Table';
import API from '../../../../services/API';

class HourFactor extends Component {
    constructor() {
        super();

        this.state = {
            factors: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.props.setLoading('HOUR_FACTOR');

        API.PcCutoff.getHourFactor().then(factors => {
            this.props.setLoaded('HOUR_FACTOR');
            this.setState({ factors })
        });
    }

    handleSave() {
        this.props.setLoading('HOUR_FACTOR_SAVE');

        API.PcCutoff.saveHourFactor(this.state.factors)
            .then(() => this.props.setLoaded('HOUR_FACTOR_SAVE'));
    }

    handleChange(event) {
        const { name, value:factor } = event.target;
        const [ day, hour ] = name.split('_');

        let { factors } = this.state;
        factors = Object.assign({}, factors);

        if(!factors[day]) factors[day] = {};

        factors[day][hour] = factor;

        this.setState({ factors });
    }

    render() {
        return (
            <div>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleSave}>Save</Button>
                        </div>
                    </Col>
                </Row>

                <Table factors={this.state.factors} onChange={this.handleChange} />
            </div>
        );
    }
}

export default HourFactor;



// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/HourFactor/index.js